<template>
  <vue-final-modal
    class="resolution-alert"
    overlay-class="resolution-alert__overlay"
  >
    <div class="logout-confirm">
      <div class="content">
        <div class="desc">
          {{ t('logoutConfirm.title') }}
        </div>
        <div class="desc__sub">
          {{ t('logoutConfirm.desc') }}
        </div>
      </div>
      <div class="buttons">
        <action-button
          class="btn"
          @click="emit('close')"
        >
          {{ t('button.cancel') }}
        </action-button>
        <action-button
          :spin="isSubmitting"
          action
          class="btn"
          @click="onSubmit"
        >
          {{ t('main.signout') }}
        </action-button>
      </div>
      <v-icon
        name="close"
        width="24"
        height="24"
        stroke="transparent"
        action-color="transparent"
        class="x-close"
        pointer
        @click="emit('close')"
      />
    </div>
  </vue-final-modal>
</template>

<script setup>
import { ref } from 'vue';
import { VueFinalModal } from 'vue-final-modal';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const emit = defineEmits({
  close: null,
  submit: null,
});

const isSubmitting = ref(false);

function onSubmit() {
  isSubmitting.value = true;
  emit('submit');
}
</script>

<style lang="scss" scoped>
.logout-confirm,
.logout-confirm * {
  box-sizing: border-box;
}

.logout-confirm {
  background: var(--color-white);
  border-radius: 20px;
  padding: 40px;
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 420px;
  position: relative;
  box-shadow: var(--shadow-medium-box-shadow, 0px 4px 40px 0px rgba(0, 0, 0, 0.08));
}

.content {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  flex-shrink: 0;
}

.desc {
  color: $primary-color-dark;
  text-align: center;
  font-family: Montserrat;
  font-size: 20px;
  font-weight: 600;
  line-height: 110%;

  &__sub {
    color: $primary-color-dark;
    text-align: center;
    font-family: Inter;
    font-size: 12px;
    font-weight: 400;
    line-height: 130%;
  }
}

.buttons {
  display: flex;
  gap: 20px;
  align-items: center;
  justify-content: center;
  align-self: stretch;
}

.x-close {
  flex-shrink: 0;
  position: absolute;
  right: 8px;
  top: 8px;
  overflow: visible;
  cursor: pointer;
}

.btn {
  width: 160px;
}
</style>
